var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBusStop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bus_stop",
    "data-name": "bus stop",
    transform: "translate(-426 -93)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3844",
    "data-name": "Rectangle 3844",
    width: 28,
    height: 28,
    transform: "translate(426 93)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_15705",
    "data-name": "Group 15705",
    transform: "translate(428.8 98.6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_3846",
    "data-name": "Rectangle 3846",
    d: "M1.948.974a.975.975,0,0,0-.974.974V12.986a.975.975,0,0,0,.974.974h9.09a.975.975,0,0,0,.974-.974V1.948a.975.975,0,0,0-.974-.974H1.948m0-.974h9.09a1.948,1.948,0,0,1,1.948,1.948V12.986a1.948,1.948,0,0,1-1.948,1.948H1.948A1.948,1.948,0,0,1,0,12.986V1.948A1.948,1.948,0,0,1,1.948,0Z",
    transform: "translate(7.629)",
    fill: "#19bc9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_14",
    "data-name": "Subtraction 14",
    d: "M1759.922-2510.779v-3.247h-1.948v3.247h1.948m.974.974H1757v-4.545a.65.65,0,0,1,.649-.649h2.6a.65.65,0,0,1,.649.649Z",
    transform: "translate(-1755.215 2526.037)",
    fill: "#19bc9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_3847",
    "data-name": "Rectangle 3847",
    d: "M.974.974V7.467H12.012V.974H.974M0,0H12.986V8.441H0Z",
    transform: "translate(7.629 2.597)",
    fill: "#19bc9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_719",
    "data-name": "Line 719",
    d: "M.224,7.142H-.75V0H.224Z",
    transform: "translate(14.709 2.922)",
    fill: "#19bc9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_717",
    "data-name": "Line 717",
    d: "M3.633.224h-3.9A.487.487,0,0,1-.75-.263.487.487,0,0,1-.263-.75h3.9a.487.487,0,0,1,.487.487A.487.487,0,0,1,3.633.224Z",
    transform: "translate(12.437 12.599)",
    fill: "#19bc9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_714",
    "data-name": "Line 714",
    d: "M-.263,2.172A.487.487,0,0,1-.75,1.685V-.263A.487.487,0,0,1-.263-.75a.487.487,0,0,1,.487.487V1.685A.487.487,0,0,1-.263,2.172Z",
    transform: "translate(3.996 9.353)",
    fill: "#19bc9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_715",
    "data-name": "Line 715",
    d: "M.224,1.948H-.75V0H.224Z",
    transform: "translate(9.84 14.284)",
    fill: "#19bc9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_720",
    "data-name": "Line 720",
    d: "M.224,1.948H-.75V0H.224Z",
    transform: "translate(16.333 14.284)",
    fill: "#19bc9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_718",
    "data-name": "Line 718",
    d: "M.224,1.948H-.75V0H.224Z",
    transform: "translate(12.437 14.284)",
    fill: "#19bc9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_721",
    "data-name": "Line 721",
    d: "M.224,1.948H-.75V0H.224Z",
    transform: "translate(18.93 14.284)",
    fill: "#19bc9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_716",
    "data-name": "Line 716",
    d: "M21.163.224H-.263A.487.487,0,0,1-.75-.263.487.487,0,0,1-.263-.75H21.163a.487.487,0,0,1,.487.487A.487.487,0,0,1,21.163.224Z",
    transform: "translate(0.75 16.495)",
    fill: "#19bc9c"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_853",
    "data-name": "Ellipse 853",
    cx: 0.649,
    cy: 0.649,
    r: 0.649,
    transform: "translate(9.901 11.687)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_853_-_Outline",
    "data-name": "Ellipse 853 - Outline",
    d: "M.649,0A.649.649,0,1,1,0,.649.649.649,0,0,1,.649,0Z",
    transform: "translate(9.901 11.687)",
    fill: "#19bc9c"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_854",
    "data-name": "Ellipse 854",
    cx: 0.649,
    cy: 0.649,
    r: 0.649,
    transform: "translate(17.043 11.687)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_854_-_Outline",
    "data-name": "Ellipse 854 - Outline",
    d: "M.649,0A.649.649,0,1,1,0,.649.649.649,0,0,1,.649,0Z",
    transform: "translate(17.043 11.687)",
    fill: "#19bc9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_852",
    "data-name": "Ellipse 852",
    d: "M2.6.974A1.623,1.623,0,1,0,4.22,2.6,1.625,1.625,0,0,0,2.6.974M2.6,0A2.6,2.6,0,1,1,0,2.6,2.6,2.6,0,0,1,2.6,0Z",
    transform: "translate(1.136 3.896)",
    fill: "#19bc9c"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusStop);
export default __webpack_public_path__ + "static/media/bus-stop.531fa4986bc7d658289c0cb1d4cc54e0.svg";
export { ForwardRef as ReactComponent };